<${input.renderBody}(state.out)/>
